import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";

interface TGlobalMessage {
  maintenance: string | null;
  setMaintenance: Dispatch<SetStateAction<string | null>>;
  infoMessage: TInfoMessage;
  setInfoMessage: Dispatch<SetStateAction<TInfoMessage>>;
  chamberMessage: TInfoMessage;
  setChamberMessage: Dispatch<SetStateAction<TInfoMessage>>;
}

type TInfoMessage = {
  date: string | null;
  message: string | null;
};

const GlobalMessageContext = createContext(null);

export function useGlobalMessage(): TGlobalMessage {
  return useContext(GlobalMessageContext as any);
}

export default function GlobalMessageProvider({ children }: any) {
  const [maintenance, setMaintenance] = useState<string | null>(null);
  const [infoMessage, setInfoMessage] = useState<TInfoMessage>({
    date: null,
    message: null,
  });
  const [chamberMessage, setChamberMessage] = useState<TInfoMessage>({
    date: null,
    message: null,
  });

  const contextValue = {
    maintenance,
    setMaintenance,
    infoMessage,
    setInfoMessage,
    chamberMessage,
    setChamberMessage,
  };

  return (
    <GlobalMessageContext.Provider value={contextValue}>
      {children}
    </GlobalMessageContext.Provider>
  );
}
